import type { CatalogEntry } from '../types';

/** AI (feature `10`) error codes + catalog. Populated in Phase 3. */
export const AI_CODES = {} as const;
export const AI_CATALOG: Record<string, CatalogEntry> = {};
